export const PROPS_PHONE_TYPE_LIST = "phoneTypeList";
export const PROPS_PHONE_NUMBER = "phoneNumber";
export const PROPS_PHONE_TYPE_NAME = "phoneTypeName";
export const PROPS_PHONE_TYPE_GUID = "phoneTypeGuid";
export const PROPS_COMPONENT_KEY = "personPhoneNumberList";
